import React, { useState } from "react";
import Header from "./Header";
import AboutMe from "./AboutMe";
import Projects from "./Projects";
import Experiences from "./Experiences";
import Footer from "./Footer";
import { Link } from "react-scroll";

const Page = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="bg-primary overflow-hidden text-[#FEFEFE]">
      <div className="max-w-7xl m-auto p-5">
        <div className="fixed top-0 left-0 z-50 w-full">
          <div className="bg-primary">
            <div className="max-w-7xl m-auto p-5">
              <div className="flex justify-between items-center md:py-6">
                <Link
                  to="header"
                  smooth={true}
                  duration={500}
                  offset={-140}
                  className="text-3xl md:text-5xl font-extrabold italic cursor-pointer font-bebas tracking-wider"
                >
                  MJ.
                </Link>
                <div className="md:hidden">
                  <button
                    onClick={toggleMobileMenu}
                    className="text-2xl font-bold cursor-pointer focus:outline-none"
                  >
                    &#9776;
                  </button>
                </div>
                <div className="hidden md:flex flex-1 justify-center gap-10 font-semibold">
                  {/* Menu for desktop */}
                  <Link
                    to="about"
                    smooth={true}
                    duration={500}
                    className="cursor-pointer"
                    offset={-140}
                  >
                    Profile
                  </Link>
                  <Link
                    to="projects"
                    smooth={true}
                    duration={500}
                    className="cursor-pointer"
                    offset={-140}
                  >
                    Projects
                  </Link>
                  <Link
                    to="experiences"
                    smooth={true}
                    duration={500}
                    className="cursor-pointer"
                    offset={-140}
                  >
                    Experiences
                  </Link>
                </div>
                <div className="hidden md:flex gap-10 font-semibold">
                  {/* Contact link for desktop */}
                  <Link
                    to="footer"
                    smooth={true}
                    duration={500}
                    offset={-140}
                    className="border border-[#FF6812] px-8 py-2 rounded-full text-[#FF6812] cursor-pointer"
                  >
                    Contact
                  </Link>
                </div>
              </div>
              {/* Mobile menu */}
              {isMobileMenuOpen && (
                <div className="md:hidden">
                  <div className="flex flex-col gap-4 mt-4">
                    <Link
                      to="about"
                      smooth={true}
                      duration={500}
                      className="cursor-pointer border-b p-2"
                      offset={-140}
                      onClick={toggleMobileMenu}
                    >
                      Profile
                    </Link>
                    <Link
                      to="projects"
                      smooth={true}
                      duration={500}
                      className="cursor-pointer border-b p-2"
                      offset={-140}
                      onClick={toggleMobileMenu}
                    >
                      Projects
                    </Link>
                    <Link
                      to="experiences"
                      smooth={true}
                      duration={500}
                      className="cursor-pointer border-b p-2"
                      offset={-140}
                      onClick={toggleMobileMenu}
                    >
                      Experiences
                    </Link>
                    <Link
                      to="footer"
                      smooth={true}
                      duration={500}
                      offset={-140}
                      className="cursor-pointer border-b p-2"
                      onClick={toggleMobileMenu}
                    >
                      Contact
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* Rest of your page components */}
        <Header />
        <AboutMe />
        <Projects />
        <Experiences />
        <Footer />
      </div>
    </div>
  );
};

export default Page;
